import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useClaimsStore } from "../../store/claims.store";

export const useClaims = () => {
  const setClaims = useClaimsStore((state) => state.setClaims);

  return useMutation(PartnerApi.claimsList, {
    onSuccess: (data) => {
      setClaims(data);
    },
    onError: (error) => {
      console.error("Claims list failed:", error);
    },
  });
};

export const useClaim = () => {
  const setClaim = useClaimsStore((state) => state.setClaim);

  return useMutation(PartnerApi.claim, {
    onSuccess: (data) => {
      setClaim(data);
    },
    onError: (error) => {
      console.error("Claim detail failed:", error);
    },
  });
};
